export default __webpack_public_path__ + "static/media/bkash.0fe4ad08.svg";